module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSuperHeavy.0bd2116.eot";